import { IconButton } from "@circle-react-uikit/HeaderV3/IconButton";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";

interface NavigationArrowProps {
  direction: "prev" | "next";
  onClick: () => void;
}

export const NavigationArrow = ({
  direction,
  onClick,
}: NavigationArrowProps) => (
  <IconButton
    name={`20-chevron-${direction === "prev" ? "left" : "right"}`}
    iconSize={20}
    onClick={onClick}
    iconClassName="!text-gray-600"
    className={classNames(
      "absolute top-1/2 z-[2] -translate-y-1/2 !rounded-full border border-gray-300 bg-white opacity-0 pointer-events-none hover:!bg-[#F7F9FA] focus:!bg-[#F7F9FA] sm:group-hover:opacity-100 sm:group-hover:pointer-events-auto focus-visible:opacity-100 focus-visible:pointer-events-auto",
      {
        "left-4": direction === "prev",
        "right-4": direction === "next",
      },
    )}
    ariaLabel={direction === "prev" ? t("previous") : t("next")}
  />
);
